import {Storage} from "@/services/Storage";
import axios from "axios";
import {responses} from "@/utils/responses";

export default {
    name: 'user-module',
    state: {
        currentUser: undefined,
        securities: [],
        users: [],
    },
    getters: {
        getCurrentUser: (state) => state.currentUser,
        getUsers: (state) => state.users,
        countNonLytSoftUsers: async (state) => {
            state.users = await Storage.getAllUsers();
            return state.users.filter(user => user.Username !== 'Admin').length;
        },

        getUserByID: (state) => async (id) => {
            state.users = await Storage.getAllUsers();
            return state.users.find(u => u.id === id);
        },
        getSecurities: (state) => state.securities,
    },
    mutations: {
        setCurrentUser: async (state, data) => {
            if (!data) {
                data = await Storage.getCurrentUser();
            }
            state.currentUser = data;
        },
        setAllSecurities: async (state, data) => {
            if (!data) data = await Storage.getAllSecurities();
            else await Storage.setAllSecurities(data);
            state.securities = data;
        },
        setAllUsers: async (state, data) => {
            if (data) {
                await Storage.setAllUsers(data)
            } else {
                data = Storage.getAllUsers();
            }
            state.users = data
        },
    },
    actions: {
        getAllUsers: async (context, payload) => {
            let store = await Storage.getDefaultStore();
            if (!store) return;
            return axios.get(franchiseTomcatApi + `employee/${store.StoreDB}/getAll`)
                .then(({data}) => {
                    context.commit('setAllUsers', data);
                    return data;
                }).catch((err) => errorHandler.tomcatError(err))
        },

        /**
         * Verifies the supervisor's PIN against the backend Argon2id store.
         * Replaces the previous broken client-side plaintext compare against
         * the cached users array. The backend's verify() auto-upgrades
         * plaintext rows to Argon2id on success.
         *
         * Response contract (POST {franchiseTomcatApi}/posAuth/{DB}/login):
         *   200 -> { success: true, empId, username, ... } -> return true
         *   400 -> empty PIN
         *   401 -> invalid PIN
         *   409 -> multiple employees share this PIN
         *   5xx -> server fault
         *
         * @param {object} context Vuex action context
         * @param {string} password Typed PIN
         * @returns {Promise<boolean>} true if backend verified; false otherwise
         */
        posLogin: async (context, password) => {
            const trimmed = (password ?? '').trim();
            if (!trimmed) return false;
            let store = await Storage.getDefaultStore();
            if (!store || !store.StoreDB) return false;
            try {
                const { data: resp } = await axios.post(
                    franchiseTomcatApi + `posAuth/${store.StoreDB}/login`,
                    { password: trimmed }
                );
                if (!resp || !resp.success) return false;
                // Mirror cached roster -> setCurrentUser, like the old flow.
                const currentUser = context.getters.getUsers.find(
                    u => u.id === resp.empId
                    || (u.Username && resp.username
                        && u.Username.toLowerCase() === resp.username.toLowerCase())
                );
                if (currentUser) {
                    await Storage.setCurrentUser(currentUser);
                    context.commit('setCurrentUser', currentUser);
                }
                return true;
            } catch (err) {
                return false;
            }
        },

        validateSecurityPermission: async (context, security) => {
            let securities = await Storage.getAllSecurities();
            let user = await Storage.getCurrentUser();
            let userType = user.Type;
            let group = securities.find(sec => sec.GroupName.toLowerCase() === userType.toLowerCase());
            if (!group) {
                await responses.showWarning(`No security group found`)
                return false;
            }
            if (!group[security]) {
                return false;
            }
            return true;
        },

        async getAllSecurities(context) {
            let store = await Storage.getDefaultStore();
            if (!store) return;
            return axios.get(franchiseTomcatApi + `empsecurity/${store.StoreDB}/getAll`)
                .then(({data}) => context.commit(`setAllSecurities`, data))
                .catch((err) => errorHandler.tomcatError(err))
        },

    }
}
